// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import EmailAttendeeSummaries from "entity/EmailAttendeeSummaries";
import MeetingAttendeeSummary, { processMeetingAttendeeSummary, processMeetingAttendeeSummaryArray } from "entity/MeetingAttendeeSummary";
import MeetingFeedback from "entity/MeetingFeedback";
import MeetingHostSummary, { processMeetingHostSummary, processMeetingHostSummaryArray } from "entity/MeetingHostSummary";
import Paging from "./Paging";
import RedoSummary from "entity/RedoSummary";
import SpeechGroup from "entity/SpeechGroup";
import User, { processUserArray } from "entity/User";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class MeetingSummaryController extends RestController {

    /*
     Email attendee summaries
     */

    emailAttendeeSummaries(message: EmailAttendeeSummaries): Promise<void> {
        const request = new RestRequest("/api/v1/summary/email", "POST", message, undefined);
        return this.requestVoid(request);
    }

    /*
     Get my attendee summaries
     */

    getAttendeeSummaries(page?: Paging): Promise<MeetingAttendeeSummary[]> {
        const request = new RestRequest("/api/v1/summary/attendee/mine", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, processMeetingAttendeeSummaryArray) as Promise<MeetingAttendeeSummary[]>;
    }

    /*
     Get an attendee summary
     */

    getAttendeeSummary(attendeeSummaryId: string): Promise<MeetingAttendeeSummary> {
        const request = new RestRequest("/api/v1/summary/attendee", "GET", null, { attendeeSummaryId: attendeeSummaryId });
        return this.request(request, processMeetingAttendeeSummary) as Promise<MeetingAttendeeSummary>;
    }

    /*
     Get my host summaries
     */

    getHostSummaries(search?: string, page?: Paging): Promise<MeetingHostSummary[]> {
        const queryParams: QueryParams = { };
        if (search !== undefined) {
          queryParams.search = search;
        }
        const request = new RestRequest("/api/v1/summary/host/mine", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processMeetingHostSummaryArray) as Promise<MeetingHostSummary[]>;
    }

    /*
     Get a host summary
     */

    getHostSummary(hostSummaryId: string): Promise<MeetingHostSummary> {
        const request = new RestRequest("/api/v1/summary/host", "GET", null, { hostSummaryId: hostSummaryId });
        return this.request(request, processMeetingHostSummary) as Promise<MeetingHostSummary>;
    }

    /*
     Get users that a host summary has been shared with
     */

    getHostSummaryShareUsers(hostSummaryId: string, page?: Paging): Promise<User[]> {
        const request = new RestRequest("/api/v1/summary/host/share", "GET", null, { hostSummaryId: hostSummaryId });
        if (page) request.addPaging("", page);

        return this.request(request, processUserArray) as Promise<User[]>;
    }

    /*
     Tells summarizer to re-summarize a speech group
    Host or attendee ID sent depending on which one it's coming from
    The summarizer will return the new SpeechGroup to this endpoint
     */

    redoSummary(message: RedoSummary): Promise<SpeechGroup> {
        const request = new RestRequest("/api/v1/summary/redo", "POST", message, undefined);
        return this.request(request, null) as Promise<SpeechGroup>;
    }

    registerForAttendeeSummary(socialRoomSetId: string, email: string): Promise<string> {
        const request = new RestRequest("/api/v1/summary/attendee/register", "POST", email, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<string>;
    }

    /*
     Sends meeting feedback to summarizer if a meeting gets feedback (thumbs up/thumbs down).
     */

    sendFeedback(feedback: MeetingFeedback): Promise<void> {
        const request = new RestRequest("/api/v1/summary/feedback", "POST", feedback, undefined);
        return this.requestVoid(request);
    }

    /*
     Share a host summary
     */

    shareHostSummary(hostSummaryId: string, userIds: string[]): Promise<void> {
        const request = new RestRequest("/api/v1/summary/host/share", "POST", userIds, { hostSummaryId: hostSummaryId });
        return this.requestVoid(request);
    }

    /*
     Stop sharing a host summary
     */

    unshareHostSummary(hostSummaryId: string, userId: string): Promise<void> {
        const request = new RestRequest("/api/v1/summary/host/unshare", "POST", null, { hostSummaryId: hostSummaryId, userId: userId });
        return this.requestVoid(request);
    }

}
